import { StarOutline } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useMemo, useEffect } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import GooglePlay from '../../images/Google Play.png'
import AppStore from '../../images/App Store.png'

const styles = {
    overlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 380,
        maxHeight: '80vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px',
    }
};

const getMobileContext = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isiOS = /iphone|ipad|ipod/.test(ua);
    const isAndroid = /android/.test(ua);
    const isStandalone =
        (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
        (window.navigator.standalone);
    const isSafari = isiOS && /safari/.test(ua) && !/crios|fxios|edgios/.test(ua);
    const isChrome = /chrome|crios/.test(ua) && !/edge|edg|opr|opera/.test(ua);
    return { isiOS, isAndroid, isStandalone, isSafari, isChrome };
}

const BookmarkPrompt = () => {
    const [state, setState] = useState({
        deferredPrompt: null,
        showInstallBtn: false
    });
    const [open, setOpen] = useState(false);
    const ctx = useMemo(getMobileContext, []);

    useEffect(() => {
        // Listen for install prompt on Android Chrome
        const onBeforeInstall = (e) => {
            e.preventDefault();
            setState({ deferredPrompt: e, showInstallBtn: true });
        };
        window.addEventListener("beforeinstallprompt", onBeforeInstall);
        return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
    }, [ctx]);

    const handleInstall = async () => {
        if (!state.deferredPrompt) return;
        await state.deferredPrompt.prompt();
        if (state.deferredPrompt.userChoice) {
            await state.deferredPrompt.userChoice.catch(() => { });
        }
        setState({ deferredPrompt: null, showInstallBtn: false });
    };

    const steps = (() => {
        if (ctx.isAndroid) {
            return {
                title: "Add to Home Screen",
                lines: [
                    "Open the browser menu (⋮).",
                    "Choose “Add to Home screen”.",
                    "Confirm by tapping Add."
                ],
                extra: ctx.isChrome ? "Or tap the Install button below if you see it." : undefined
            };
        }
        if (ctx.isiOS && ctx.isSafari) {
            return {
                title: "Add to Home Screen (iPhone/iPad – Safari)",
                lines: [
                    "Tap the Share icon (square with arrow).",
                    "Scroll and tap “Add to Home Screen”.",
                    "Tap Add."
                ]
            };
        }
        if (ctx.isiOS && !ctx.isSafari) {
            return {
                title: "Add to Home Screen (iPhone/iPad)",
                lines: [
                    "Tap the Share icon.",
                    "Find “Add to Home Screen”. If not available, open this site in Safari and try again:"
                ],
                extra: window.location.href
            };
        }
        return {
            title: "Add a Bookmark",
            lines: [
                "Open your browser menu.",
                "Choose “Bookmark” or tap the ★ (star) icon.",
                "Confirm to save."
            ]
        };
    })();

    const bookmarkSteps = (() => {
        if (ctx.isiOS && ctx.isSafari) {
            return [
                "Tap the Share icon",
                "Tap “Add Bookmark…”",
                "Choose a folder and tap Save"
            ];
        }
        return [
            "Open the browser menu (⋮ or ☰)",
            "Tap the ★ (star) icon or “Bookmark”",
            "Confirm to save"
        ];
    })();

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
    };

    return (
        <>
            {/* Trigger button */}
            <div style={{
                background: 'rgb(239, 243, 254)',
                width: '40px',
                height: '40px',
                padding: '7px',
                borderRadius: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
            }}
                onClick={() => setOpen(true)}
            >
                <StarOutline fontSize="small" />
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
                disableEscapeKeyDown
            >
                <Box sx={styles.overlay} className="modal-body">

                    {/* Close button */}
                    <div style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer' }} onClick={() => setOpen(false)}>
                        <CloseIcon />
                    </div>

                    {/* Instructions */}
                    <div className="mb-4">
                        {/* <Typography variant="h6" fontWeight={600} gutterBottom>
                            {steps.title}
                        </Typography>

                        <ol style={{ paddingLeft: 18, marginTop: 8 }}>
                            {steps.lines.map((l, i) => (
                                <li key={i} style={{ marginBottom: 8 }}>{l}</li>
                            ))}
                        </ol>

                        {steps.extra && (
                            <Typography sx={{ marginTop: 2, wordBreak: "break-all" }}>
                                {steps.extra}
                            </Typography>
                        )} */}

                        {/* {state.showInstallBtn && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleInstall}
                                sx={{ marginTop: 2 }}
                            >
                                Install App
                            </Button>
                        )} */}

                        {/* <hr style={{ margin: "16px 0" }} /> */}

                        <Typography variant="h6" mb={1} fontWeight={600}>
                            Add a Bookmark?
                        </Typography>
                        <ol style={{ paddingLeft: 18 }}>
                            {bookmarkSteps.map((l, i) => (
                                <li key={i} style={{ marginBottom: 8 }}>{l}</li>
                            ))}
                        </ol>
                    </div>
                    <hr />
                    <div className='mt-4'>
                         <Typography variant="h6" className='my-1' fontWeight={600} gutterBottom>
                            Download the QRTag.it App Now
                         </Typography>
                        <p style={{ color: '#64748B', fontSize: '14px', fontWeight: 400, }}>
                            What are you waiting for? Download the QRTag.it App now! The user interface of QRTag.it is simple and easy to navigate
                        </p>
                    </div>
                    <div className='d-flex'>
                        <a href="https://apps.apple.com/us/app/qrtag-it/id6444082603" target="_blank">
                            <img
                                src={AppStore}
                                style={{ width: '120px', height: 'auto', marginRight: '10px' }}
                                alt='App Store'
                            />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.withered_feather_36062" target="_blank">
                            <img
                                src={GooglePlay}
                                style={{ width: '120px', height: 'auto' }}
                                alt='Google Play'
                            />
                        </a>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default BookmarkPrompt;
